export var LINK_CLASSNAME_MAP = {
  whatsapp: 'whatsapp-link',
  telegram: 'telegram-link',
  callback: 'callback-link',
  chat: 'chat-link'
};
export var LINK_TOOLTIP_TEXT_MAP = {
  whatsapp: 'Чат в WhatsApp',
  telegram: 'Чат в Telegram',
  callback: 'Заказать звонок консультанту',
  chat: 'Онлайн чат'
};